(() => {
  class FranchisePage extends HTMLElement {
    updateToday(){
      const day=new Intl.DateTimeFormat('fr-FR',{weekday:'long',timeZone:'Europe/Paris'}).format(new Date()).toLocaleLowerCase('fr-FR');
      this.querySelectorAll('.sm-franchise__hours-list>p').forEach(row=>{
        const active=row.textContent.trim().toLocaleLowerCase('fr-FR').startsWith(day);
        row.classList.toggle('is-today',active);
        if(active)row.setAttribute('aria-current','date');else row.removeAttribute('aria-current');
      });
    }
    connectedCallback(){
      const back=this.querySelector('[data-return-search]');
      try{const saved=JSON.parse(sessionStorage.getItem('sm-locator-search'));if(saved && back){const url=new URL(saved.url,location.origin);if(url.origin===location.origin && url.pathname==='/pages/maisons-de-beaute-simone-mahler'){url.searchParams.set('retour','recherche');back.href=url.pathname+url.search;}}}catch(e){}
      this.updateToday();
      if(!this.dayTimer)this.dayTimer=setInterval(()=>this.updateToday(),60000);
      if(this.observer || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      this.observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.remove('is-pending');this.observer.unobserve(entry.target);}}},{threshold:0.08});
      this.classList.add('is-animated');
      this.querySelectorAll('[data-reveal]').forEach(el=>{if(el.getBoundingClientRect().top>window.innerHeight){el.classList.add('is-pending');this.observer.observe(el);}});
    }
    disconnectedCallback(){clearInterval(this.dayTimer);this.dayTimer=null;this.observer?.disconnect();this.observer=null;this.classList.remove('is-animated');this.querySelectorAll('.is-pending').forEach(el=>el.classList.remove('is-pending'));}
  }
  if(!customElements.get('sm-franchise-page'))customElements.define('sm-franchise-page',FranchisePage);
})();
